import type {
  ModifierDetails,
  Reference,
  StoreObject,
} from '@apollo/client/cache';
import type { AsStoreObject } from '@apollo/client/utilities';

const removeReferenceById =
  <Entity extends { __typename?: string }>(id: string) =>
  (
    refs: readonly (Reference | AsStoreObject<Entity>)[] | undefined,
    { readField }: ModifierDetails,
  ) =>
    refs?.filter((ref) => readField('id', ref as StoreObject) !== id);

export default removeReferenceById;
